import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import AlertModalManager from "../../components/alert-modal-wraper/alert-modal-manager";

import { validateKeylessPin, sendKeylessPin } from "./keylessService";
import { KeylessPageLayoutView } from "./KeylessPage";

export function KeylessValidatePin({
  handleNextStep,
  keylessToken,
  hasSentPin,
}) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);

  const [pinSent, setPinSent] = useState(false);
  const [pin, setPin] = useState("");

  const handleSendPinClick = useCallback(() => {
    setIsLoading(true);
    setPinSent(false);
    sendKeylessPin(keylessToken)
      .then((res) => {
        setPinSent(true);
      })
      .catch((err) => {
        const messageKey = err.response.data;
        AlertModalManager.openModal(
          { title: t(messageKey), message: "" },
          () => {}
        );
      })
      .finally(() => setIsLoading(false));
  }, [keylessToken, pin]);

  const handleValidatePinClick = useCallback(() => {
    setIsLoading(true);
    validateKeylessPin(keylessToken, pin)
      .then((res) => {
        handleNextStep(res.nextStep);
      })
      .catch((err) => {
        setIsLoading(false);
        const messageKey = err.response.data;
        AlertModalManager.openModal(
          { title: t(messageKey), message: "" },
          () => {}
        );
      })
  }, [keylessToken, pin, handleNextStep]);

  const pinSentNowOrBefore = hasSentPin || pinSent;

  return (
    <KeylessPageLayoutView>
      <h1>
        Iremos enviar um sms com o código de acesso que deverá introduzir em seguida
      </h1>
      {pinSentNowOrBefore ? (
        <div>
          <form className="text-center">
            <label htmlFor="nif">Pin recebido</label>
            <input
              type="number"
              className={`form-control text-center`}
              value={pin}
              onChange={(e) => setPin(e.target.value)}
            />
            <div
              className="btn btn-green text-uppercase mt-4"
              onClick={handleValidatePinClick}
            >
              Validar pin
            </div>
          </form>
        </div>
      ) : (
        <div>
          <div
            className="btn btn-green text-uppercase"
            onClick={handleSendPinClick}
          >
            Enviar pin
          </div>
        </div>
      )}
    </KeylessPageLayoutView>
  );
}
